import axios from "axios";
import { API_END_POINT } from "../../../constants/api";

// yarn quality

export function addyarnQuality(yarnQualityData) {
  let authToken = localStorage.getItem("usertoken");

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };

  const body = JSON.stringify(yarnQualityData);
  let response = axios.post(
    `${API_END_POINT}/company/setting/yarn-quality/add`,
    body,
    config
  );

  return response;
}

export function getyarnQualities(parmas) {
  let authToken = localStorage.getItem("usertoken");

  let { companyId, limit } = parmas;
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };

  let response = axios.get(
    `${API_END_POINT}/company/setting/yarn-quality/get/${companyId}/limit=${
      limit && limit
    }`,
    config
  );

  return response;
}

export function getSingleYarnQuality(yarnQualityId) {
  let authToken = localStorage.getItem("usertoken");

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };

  let response = axios.get(
    `${API_END_POINT}/company/setting/yarn-quality/get/${yarnQualityId}`,
    config
  );

  return response;
}

export function deleteYarnQuality(yarnQualityId) {
  let authToken = localStorage.getItem("usertoken");

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };

  let response = axios.delete(
    `${API_END_POINT}/company/setting/yarn-quality/delete/${yarnQualityId}`,
    config
  );

  return response;
}

export function updateYarnQuality(yarnQualityId, updatedData) {
  let authToken = localStorage.getItem("usertoken");

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };

  const body = JSON.stringify(updatedData);

  let response = axios.put(
    `${API_END_POINT}/company/setting/yarn-quality/update/${yarnQualityId}`,
    body,
    config
  );

  return response;
}

// cloth quality

export function addClothQuality(clothQualityData) {
  let authToken = localStorage.getItem("usertoken");

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };

  const body = JSON.stringify(clothQualityData);
  let response = axios.post(
    `${API_END_POINT}/company/setting/cloth-quality/add`,
    body,
    config
  );

  return response;
}

export function getAllClothQualities(parmas) {
  let authToken = localStorage.getItem("usertoken");

  let { companyId, limit } = parmas;
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };

  let response = axios.get(
    `${API_END_POINT}/company/setting/cloth-quality/get/${companyId}/limit=${
      limit && limit
    }`,
    config
  );

  return response;
}

export function getSingleClothQuality(clothQualityId) {
  let authToken = localStorage.getItem("usertoken");

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };

  let response = axios.get(
    `${API_END_POINT}/company/setting/cloth-quality/get/${clothQualityId}`,
    config
  );

  return response;
}

export function deleteClothQuality(clothQualityId) {
  let authToken = localStorage.getItem("usertoken");

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };

  let response = axios.delete(
    `${API_END_POINT}/company/setting/cloth-quality/delete/${clothQualityId}`,
    config
  );

  return response;
}

export function updateClothQuality(clothQualityId, updatedData) {
  let authToken = localStorage.getItem("usertoken");

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  const body = JSON.stringify(updatedData);

  let response = axios.put(
    `${API_END_POINT}/company/setting/cloth-quality/update/${clothQualityId}`,
    body,
    config
  );

  return response;
}

// weave

export function addWeave(weaveData) {
  let authToken = localStorage.getItem("usertoken");

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };

  const body = JSON.stringify(weaveData);
  let response = axios.post(
    `${API_END_POINT}/company/setting/weave/add`,
    body,
    config
  );

  return response;
}

export function getAllWeave(parmas) {
  let authToken = localStorage.getItem("usertoken");

  let { companyId, limit } = parmas;
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };

  let response = axios.get(
    `${API_END_POINT}/company/setting/weave/get/${companyId}/limit=${
      limit && limit
    }`,
    config
  );

  return response;
}

export function getSingleWeave(weaveId) {
  let authToken = localStorage.getItem("usertoken");

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };

  let response = axios.get(
    `${API_END_POINT}/company/setting/weave/get/${weaveId}`,
    config
  );

  return response;
}

export function deleteWeave(weaveId) {
  let authToken = localStorage.getItem("usertoken");

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };

  let response = axios.delete(
    `${API_END_POINT}/company/setting/weave/delete/${weaveId}`,
    config
  );

  return response;
}

export function updateWeave(weaveId, updatedData) {
  let authToken = localStorage.getItem("usertoken");

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };

  const body = JSON.stringify(updatedData);

  let response = axios.put(
    `${API_END_POINT}/company/setting/weave/update/${weaveId}`,
    body,
    config
  );

  return response;
}

// selvedge

export function addSelvedge(selvedgeData) {
  let authToken = localStorage.getItem("usertoken");

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };

  const body = JSON.stringify(selvedgeData);
  let response = axios.post(
    `${API_END_POINT}/company/setting/selvedge/add`,
    body,
    config
  );

  return response;
}

export function getAllSelvedge(parmas) {
  let authToken = localStorage.getItem("usertoken");

  let { companyId, limit } = parmas;
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };

  let response = axios.get(
    `${API_END_POINT}/company/setting/selvedge/get/${companyId}/limit=${
      limit && limit
    }`,
    config
  );

  return response;
}

export function getSingleSelvedge(selvedgeId) {
  let authToken = localStorage.getItem("usertoken");

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };

  let response = axios.get(
    `${API_END_POINT}/company/setting/selvedge/get/${selvedgeId}`,
    config
  );

  return response;
}

export function deleteSelvedge(selvedgeId) {
  let authToken = localStorage.getItem("usertoken");

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };

  let response = axios.delete(
    `${API_END_POINT}/company/setting/selvedge/delete/${selvedgeId}`,
    config
  );

  return response;
}

export function updateSelvedge(selvedgeId, updatedData) {
  let authToken = localStorage.getItem("usertoken");

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };

  const body = JSON.stringify(updatedData);

  let response = axios.put(
    `${API_END_POINT}/company/setting/selvedge/update/${selvedgeId}`,
    body,
    config
  );

  return response;
}

// hs code

export function addHsCode(hsCodeData) {
  let authToken = localStorage.getItem("usertoken");

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };

  const body = JSON.stringify(hsCodeData);
  let response = axios.post(
    `${API_END_POINT}/company/setting/hs-code/add`,
    body,
    config
  );

  return response;
}

export function getAllHsCode(parmas) {
  let authToken = localStorage.getItem("usertoken");

  let { companyId, limit } = parmas;
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };

  let response = axios.get(
    `${API_END_POINT}/company/setting/hs-code/get/${companyId}/limit=${
      limit && limit
    }`,
    config
  );

  return response;
}

export function getSingleHsCode(hsCodeId) {
  let authToken = localStorage.getItem("usertoken");

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };

  let response = axios.get(
    `${API_END_POINT}/company/setting/hs-code/get/${hsCodeId}`,
    config
  );

  return response;
}

export function deleteHsCode(hsCodeId) {
  let authToken = localStorage.getItem("usertoken");

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };

  let response = axios.delete(
    `${API_END_POINT}/company/setting/hs-code/delete/${hsCodeId}`,
    config
  );

  return response;
}

export function updateHscode(hsCodeId, updatedData) {
  let authToken = localStorage.getItem("usertoken");

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };

  const body = JSON.stringify(updatedData);

  let response = axios.put(
    `${API_END_POINT}/company/setting/hs-code/update/${hsCodeId}`,
    body,
    config
  );

  return response;
}
